const featureAlert = Vue.component('feature-alert', {
  template: "#feature-alert",

  data() {
      return {
        featureAlert: null,
      }
  },

  methods: {
    close() {
      this.notificationLog(this.featureAlert.id, "close")
      $('.feature-alert').hide()
    },

    notificationLog(id, type) {
      $.ajax({
        method: "POST",
        url: `/a/pop-up-notification/analytics/${id}`,
        data: {
            type
        },
      }).then(r => {})
    },
  },

  async mounted(){
    await $.ajax({
      url: `/a/pop-up-notifications`,
      data: {
          type: "feature-alert",
          page: window.location.pathname,
          publishNow: true
      },
    }).done(r => {
        if(r){
            this.featureAlert = r;
            const contentUk = this.featureAlert.contentUk ? this.featureAlert.contentUk : ""
            const contentUs = this.featureAlert.contentUs ? this.featureAlert.contentUs : ""
            this.featureAlert.content = contentUk

            var refreshTargetIntervalId = setInterval(function(featureAlert) {
              if($('#' + featureAlert.target).length > 0){
                const targetWidth = $('#' + featureAlert.target).width()
                const targetHeight = $('#' + featureAlert.target).height()
                const targetOuterWidth = $('#' + featureAlert.target).outerWidth()
                const targetOuterHeight = $('#' + featureAlert.target).outerHeight()
                const targetOffset = $('#' + featureAlert.target).offset()

                var refreshIntervalId = setInterval(function(position) {
                  if($('.feature-alert').length > 0){
                    const width = $('.feature-alert').width()
                    const height = $('.feature-alert').height();
                    const outerWidth = $('.feature-alert').outerWidth()
                    const outerHeight = $('.feature-alert').outerHeight();

                    let offsetTop = 0
                    let offsetLeft = -314
                    if(position == 'left'){
                      offsetTop = targetOffset.top - ((height / 2) - (targetHeight / 2))
                      offsetLeft = targetOffset.left - 314
                    } else if(position == 'right'){
                      offsetTop = targetOffset.top - ((height / 2) - (targetHeight / 2))
                      offsetLeft = targetOffset.left + targetOuterWidth + 8
                    } else if(position == 'top'){
                      offsetTop = targetOffset.top - outerHeight - 8
                      offsetLeft = targetOffset.left + ((targetOuterWidth / 2) - (outerWidth / 2))
                    } else if(position == 'bottom'){
                      offsetTop = targetOffset.top + targetOuterHeight + 8
                      offsetLeft = targetOffset.left + ((targetOuterWidth / 2) - (outerWidth / 2))
                    }

                    $('.feature-alert').offset({ top: offsetTop, left: offsetLeft })
                    clearInterval(refreshIntervalId)
                  }
                }, 250, featureAlert.position);

                clearInterval(refreshTargetIntervalId)
              }
            }, 250, this.featureAlert);

        } else {
          $('.feature-alert').hide()
        }
    })
  }
})
